import { CommonActivityType } from './activity-history/common-activity-type.enum';

/**
 * Activity types tracked in the issue_activity table.
 * Extends CommonActivityType with Issue-specific types.
 */
export const IssueActivityType = {
	...CommonActivityType,
	// Issue-specific types
	WATCHER_ADDED: 'watcher_added',
	WATCHER_REMOVED: 'watcher_removed',
} as const;

export type IssueActivityType =
	(typeof IssueActivityType)[keyof typeof IssueActivityType];

export type IssueActivityTypeValue = IssueActivityType;
